import { checkBadEnabledDateRange } from './checkBadDates';
const debug = process.env.REACT_APP_DEBUG && false;
export const deOverlapRanges = ({ ranges }) => {
    const deOveralppedRangess = ranges.reduce(deOverlapper, []);
    return deOveralppedRangess;
};
/** mutates previous end dates to next start date, on the assumption that the most recent message will be correctest */
const deOverlapper = (a, next, i, arr) => {
    if (i > 0) {
        const last = arr.at(i - 1);
        if (last && next) {
            const lastFrom = last.dateRange.at(0);
            const lastTo = last.dateRange.at(1);
            const nextFrom = next.dateRange.at(0);
            if (process.env.NODE_ENV === 'development')
                checkBadEnabledDateRange([last, next], 'deoverlapper internal');
            if (lastTo && nextFrom && lastTo > nextFrom) {
                if (lastFrom && lastFrom > nextFrom) {
                    // where appended scheduled time are before the start of the last reported period
                    next.dateRange[0] = new Date(lastTo);
                }
                else {
                    last.dateRange[1] = new Date(nextFrom);
                }
                if (last.dateRange[1] < last.dateRange[0]) {
                    console.log(`ERR: deOverlapper caused duff time range`, { last, next });
                    throw new Error(`deOverlapper caused duff time range`);
                }
            }
        }
        a.push(next);
    }
    else {
        a.push(next);
    }
    if (process.env.NODE_ENV === 'development')
        checkBadEnabledDateRange(a, 'deoverlapper');
    return a;
};
